export default "__VITE_ASSET__Dk$kdApD__"